export const BACKEND_HOST = "https://api.behaton.me";
